import React, { FC } from 'react';
import { Span } from "../Text/Text";
import Select from "react-select";
import { customAmountToggleSelectStyles } from "./customSelectStyles";

import styles from './amountToggle.module.scss';

const amount = [10, 25, 50, 100];

type AmountTogglePropTypes = {
    changeAmount: (value: number) => void;
    labelText?: string;
    defaultLimit?: number;
    /** Current value (for controlled mode - keeps display in sync when parent state changes) */
    value?: number;
}

const AmountToggle: FC<AmountTogglePropTypes> = ({ changeAmount, labelText, defaultLimit, value }) => {
    const handleChange = (item: any) => {
        changeAmount(item.value);
    };

    const currentValue = value ?? defaultLimit ?? amount[0];
    const selectValue = { value: currentValue, label: currentValue };

    return (
        <div className={styles.wrapper}>
            <Span className={styles.label}>{labelText ? labelText + ': ' : 'Show: '}</Span>
            <Select
                options={amount.map(n => ({ value: n, label: n })) as any}
                value={selectValue}
                styles={customAmountToggleSelectStyles}
                isSearchable={false}
                onChange={handleChange}
                menuPlacement="top"
            />
        </div>
    );
};

export default AmountToggle;